import { useId, useState } from "react";
import "../styles/metric-tooltip.css";

export default function MetricInfoTooltip({ label, description, align = "center" }) {
  const tooltipId = useId();
  const [open, setOpen] = useState(false);

  return (
    <span className="cg-info-label">
      <span>{label}</span>
      <span className={`cg-info-tooltip cg-info-tooltip-${align}${open ? " is-open" : ""}`}>
        <button
          type="button"
          className="cg-info-tooltip-button"
          aria-label={`About ${label}`}
          aria-expanded={open}
          aria-controls={tooltipId}
          onClick={() => setOpen((current) => !current)}
          onKeyDown={(event) => {
            if (event.key === "Escape") setOpen(false);
          }}
        >
          i
        </button>
        <span id={tooltipId} role="tooltip" className="cg-info-tooltip-content">
          {description}
        </span>
      </span>
    </span>
  );
}
